import axiosInstance from '../../Utils/axiosInstance';
import {
  FixActionResponse,
  FixSessionData,
  FixSessionResponse,
  FixStatusResponse,
  PlatformType,
} from './Exchangeconnectivitymanagement.types';

export const ENDPOINTS: Record<PlatformType, { start: string; stop: string; session: string }> = {
  WebICE: {
    start: '/paper-app/fix/webice_start/',
    stop: '/paper-app/fix/webice_stop/',
    session: '/paper-app/fix/Session_Status_Webice/',
  },
  TT: {
    start: '/paper-app/fix/tt_start/',
    stop: '/paper-app/fix/tt_stop/',
    session: '/paper-app/fix/Session_Status_TT/',
  },
};

export const STATUS_ENDPOINTS: Record<PlatformType, string> = {
  WebICE: '/paper-app/fix/webice_status/',
  TT: '/paper-app/fix/tt_status/',
};

export const fetchFixSessionStatus = async (
  platform: PlatformType
): Promise<FixSessionData> => {
  const { data } = await axiosInstance.get<FixSessionResponse>(ENDPOINTS[platform].session);
  return data.fix_session;
};

export const toggleFixConnection = async (
  platform: PlatformType,
  currentlyConnected: boolean
): Promise<FixActionResponse> => {
  const url = currentlyConnected ? ENDPOINTS[platform].stop : ENDPOINTS[platform].start;
  const { data } = await axiosInstance.post<FixActionResponse>(url);
  return data;
};

export const fetchFixConnectionStatus = async (
  platform: PlatformType
): Promise<{ connected: boolean }> => {
  const { data } = await axiosInstance.get<FixStatusResponse>(STATUS_ENDPOINTS[platform]);
  return { connected: data.running.connection.connected };
};